"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TrackPoint = (function () {
    function TrackPoint(logger, onLimiTrack) {
        this.eventDic = new Map();
        this.logger = logger;
        this.onLimiTrack = onLimiTrack;
        this.autoBind();
        this.init();
    }
    TrackPoint.prototype.autoBind = function () {
    };
    TrackPoint.prototype.init = function () {
        if (typeof document === 'undefined') {
            return;
        }
        this.addHook();
    };
    TrackPoint.prototype.addHook = function () {
        var that = this;
        try {
            var htmlAddEventListener_1 = HTMLElement.prototype.addEventListener;
            HTMLElement.prototype.addEventListener = function (type, listener, userCapture) {
                var you = this;
                var fun = function (event) {
                    if (TrackPoint.WATCH_EVENTS.indexOf(event.type) !== -1) {
                        that.onTrack(event);
                    }
                    listener.apply(you, [event]);
                };
                that.eventDic.set(listener, fun);
                return htmlAddEventListener_1.apply(this, [type, fun, userCapture]);
            };
        }
        catch (e) {
            console.log(e);
        }
        try {
            var htmlRemoveEventListener_1 = HTMLElement.prototype.removeEventListener;
            HTMLElement.prototype.removeEventListener = function (type, listener, userCapture) {
                var fun = that.eventDic.get(listener);
                if (!fun) {
                    fun = listener;
                }
                return htmlRemoveEventListener_1.apply(this, [type, fun, userCapture]);
            };
        }
        catch (e) {
            console.log(e);
        }
    };
    TrackPoint.prototype.onTrack = function (event) {
        if (event === undefined)
            event = window.event;
        var target = 'target' in event ? event.target : event.srcElement;
        try {
            var xPath = this.getPathTo(target);
            var el = this.getElementByXPath(xPath);
            var txt = el ? el.innerText : '';
            var log = this.onLimiTrack(event.type, xPath, txt.substr(0, 10));
            this.logger.info(log);
        }
        catch (e) {
            return;
        }
    };
    TrackPoint.prototype.getPathTo = function (element) {
        if (element.id !== '')
            return '//*[@id=\'' + element.id + '\']';
        if (element === document.body) {
            return element.tagName.toLowerCase();
        }
        var ix = 0;
        var siblings = element.parentNode.childNodes;
        for (var i = 0; i < siblings.length; i++) {
            var sibling = siblings[i];
            if (sibling === element) {
                return this.getPathTo(element.parentNode) + '/' + element.tagName.toLowerCase() + '[' + (ix + 1) + ']';
            }
            if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
                ix++;
            }
        }
    };
    TrackPoint.prototype.getPathTo2 = function (element) {
        if (element.tagName === 'HTML') {
            return '/HTML[1]';
        }
        if (element === document.body) {
            return '/HTML[1]/BODY[1]';
        }
        var ix = 0;
        var siblings = element.parentNode.childNodes;
        for (var i = 0; i < siblings.length; i++) {
            var sibling = siblings[i];
            if (sibling === element) {
                return this.getPathTo2(element.parentNode) + '/' + element.tagName + '[' + (ix + 1) + ']';
            }
            if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
                ix++;
            }
        }
    };
    TrackPoint.prototype.getElementByXPath = function (xPath) {
        return document.evaluate(xPath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    };
    TrackPoint.WATCH_EVENTS = ['click', 'mouseup', 'mousedown'];
    return TrackPoint;
}());
exports.TrackPoint = TrackPoint;
//# sourceMappingURL=TrackPoint.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/log/TrackPoint.js
// module id = DSZX
// module chunks = 0